import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { WHATSAPP_URL } from "../../utils/contact";
import { gaEvent } from "../../analytics";
import { FOOTER_WHATSAPP_CTA } from "../../pages/shared/constants";
import { FooterWhatsAppButton } from "../../pages/shared/styledComponents";

/**
 * The persistent "Escríbenos" action in the landing page's sticky bottom bar.
 *
 * `component="a"` so this is a single anchor styled as a button. Wrapping a `<button>` in an
 * `<a>` — the pattern `ContactTheExpertButton` uses — nests interactive content and gives screen
 * readers two controls where there is one action.
 */
const FooterWhatsAppCta: React.FC = () => (
  <FooterWhatsAppButton
    component="a"
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    startIcon={<WhatsAppIcon />}
    onClick={() => gaEvent("whatsapp_click", { source: "footer_cta" })}
  >
    {FOOTER_WHATSAPP_CTA}
  </FooterWhatsAppButton>
);

export default FooterWhatsAppCta;
